import { render } from "./ScrollModel.vue?vue&type=template&id=223245ca&scoped=true"
import script from "./ScrollModel.vue?vue&type=script&lang=js"
export * from "./ScrollModel.vue?vue&type=script&lang=js"

import "./ScrollModel.vue?vue&type=style&index=0&id=223245ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223245ca"]])

export default __exports__